/**
 * Keeps first-view lead capture from hiding the main brand promise.
 * The site already has newsletter capture lower on the page; this closes aggressive app popups on initial load.
 */
(function () {
  const CLOSE_SELECTORS = [
    '.qsk-popup__close',
    '.klaviyo-close-form',
    '[aria-label="Close popup"]',
    '[aria-label="Close dialog"]'
  ];
  const OBSERVE_MS = 12000;
  const SCAN_INTERVAL_MS = 500;
  const COPY_REPLACEMENTS = [
    ['CALISTENIA PARA QUIEN QUIERE MAS DE SI MISMO', 'CALISTENIA PARA QUIEN QUIERE MÁS DE SÍ MISMO'],
    ['Conviertete en el atleta que prometiste ser', 'Conviértete en el atleta que prometiste ser'],
    ['fuerza y caracter', 'fuerza y carácter'],
    ['tension', 'tensión'],
    ['sesion', 'sesión'],
    ['PROPOSITO', 'PROPÓSITO'],
    ['Mas que equipo', 'Más que equipo'],
    ['musculos', 'músculos'],
    ['Unete a la comunidad', 'Únete a la comunidad'],
    ['LEE MAS', 'LEER MÁS'],
    ['LEER MAS', 'LEER MÁS']
  ];
  const clickedButtons = new WeakSet();
  let scheduled = false;
  const allowLeadPopup = new URLSearchParams(window.location.search).has('show_lead_popup');

  if (allowLeadPopup) {
    document.documentElement.classList.add('benard-show-lead-popup');
  }

  function isVisible(element) {
    const rect = element.getBoundingClientRect();
    const styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function closeLeadModals() {
    if (allowLeadPopup) {
      return;
    }

    CLOSE_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((button) => {
        if (button instanceof HTMLElement && !clickedButtons.has(button) && isVisible(button)) {
          clickedButtons.add(button);
          button.click();
        }
      });
    });

    document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function normalizeMarketingCopy() {
    const target = document.querySelector('.benard-athlete') || document.body;
    if (!target) {
      return;
    }

    const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      let text = node.nodeValue || '';
      COPY_REPLACEMENTS.forEach(([from, to]) => {
        text = text.replaceAll(from, to);
      });
      node.nodeValue = text;
      node = walker.nextNode();
    }
  }

  function scheduleClose() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.setTimeout(() => {
      scheduled = false;
      normalizeMarketingCopy();
      closeLeadModals();
    }, 50);
  }

  function startObserver() {
    normalizeMarketingCopy();
    closeLeadModals();

    const observer = new MutationObserver(scheduleClose);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    const intervalId = window.setInterval(closeLeadModals, SCAN_INTERVAL_MS);

    window.setTimeout(() => {
      observer.disconnect();
      window.clearInterval(intervalId);
    }, OBSERVE_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
